import * as C from "../../../constants";

const initialState = {
  devices: [],
  page: 1,
  total: 0,
  hasNext: false,
  next: 0,
  limit: 100,
  isLoading: false,
  isFetchingMore: false,
  errorMessage: "",
};

export default function batteries(state = initialState, action) {
  switch (action.type) {
    case C.BATTERY_DEVICES_REQUEST:
      // Clear prior results so switching members doesn't briefly show the
      // previous member's devices while the new fetch is in flight.
      return { ...state, isLoading: true, errorMessage: "", devices: [], total: 0, page: 1, hasNext: false, next: 0 };

    case C.BATTERY_DEVICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        devices: action.payload.devices || [],
        page: action.payload.page || 1,
        total: action.payload.total || 0,
        hasNext: action.payload.has_next || false,
        next: action.payload.next || 0,
      };

    case C.BATTERY_DEVICES_FETCH_MORE_REQUEST:
      return { ...state, isFetchingMore: true };

    case C.BATTERY_DEVICES_FETCH_MORE_SUCCESS:
      return {
        ...state,
        isFetchingMore: false,
        devices: [...state.devices, ...(action.payload.devices || [])],
        page: action.payload.page || state.page,
        total: action.payload.total || state.total,
        hasNext: action.payload.has_next || false,
        next: action.payload.next || 0,
      };

    case C.BATTERY_DEVICES_FAILURE:
      return { ...state, isLoading: false, isFetchingMore: false, errorMessage: action.error };

    default:
      return state;
  }
}
